import { EditFeatureState } from "../editFeature.reducer";
import { IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { EditMode } from "../../types";
import { mapFeatureToCollection } from "../../../core/geo/geometryMapper";
import { Feature, GeometryType } from "../../../core/geo/types";
import { isPolygon } from "../../../core/geo/assertions";

const appendFirstElementToEnd = (feature: Feature) => {
    if (isPolygon(feature.geometry) && feature.geometry.coordinates && feature.geometry.coordinates.length > 0) {
        const coordinates = [...feature.geometry.coordinates];
        const lastElementIndex = coordinates[0].length - 1;
        for (const groupIndex in coordinates) {
            if (
                coordinates[groupIndex][0][0] !== coordinates[groupIndex][lastElementIndex][0] &&
                coordinates[groupIndex][0][1] !== coordinates[groupIndex][lastElementIndex][1]
            ) {
                coordinates[groupIndex].push(coordinates[groupIndex][0]);
            }
        }
    }
};

export const viewGeometryPartialReducer: IPartialReducer<EditFeatureState> = (state, action) => {
    const feature = action.geoJsonFeature;
    let editedFeature;
    if (feature) {
        editedFeature = mapFeatureToCollection({
            ...feature,
            properties: {
                ...feature.properties,
                style: state.style,
                densifyGeometry: false,
            },
        });
    }
    appendFirstElementToEnd(feature);
    return {
        ...state,
        editedFeatures: editedFeature,
        editMode: EditMode.NUMERICAL,
        geometryType: feature && (feature.geometry.type as GeometryType),
    };
};
